import React from 'react';
import timeIcon from './img/time-icon.svg';
import { DuelsPlayerSpinWheel } from './duels-player-spin-wheel';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import DuelIcon from '@/components/custom/icons/DuelIcon';
import { useSession } from '@/hooks/useSession';
import {
  ChallengeModalAvatar,
  ChallengeModalDuel,
  ChallengeModalHat,
  ChallengeModalName,
  ChallengeModalNumber,
  ChallengeModalProfile,
  ChallengeModalScore,
  ChallengeModalSection,
  ChallengeModalSectionNameSubtitle,
  ChallengeModalStar,
  ChallengeModalVs,
  ChallengeModalWarning
} from '@/components/custom/challenge';
import { AvatarWrapper } from '@/components/ui/avatar';

export function DuelsPlayerStepName({ duel }) {
  const { currentChallenge, rightAnswers } = useWeeklyChallenge();
  const { session } = useSession();

  const userAvatar = session?.user?.image?.url;
  const opponentAvatar = duel?.opponent?.image?.url;

  return (
    <ChallengeModalSection variant="name">
      <ChallengeModalHat>
        {duel?.['parent-taxonomy']?.name}
        <ChallengeModalSectionNameSubtitle>
          <DuelIcon /> Duelo
        </ChallengeModalSectionNameSubtitle>
      </ChallengeModalHat>

      <ChallengeModalDuel>
        <ChallengeModalProfile>
          <ChallengeModalAvatar>
            <AvatarWrapper
              size="md"
              src={duel?.['creator-id'] === session?.user?.id ? userAvatar : opponentAvatar}
              text={duel?.['creator-id'] === session.user.id ? session.user.name : duel?.opponent?.name}
            />
            <ChallengeModalStar />
          </ChallengeModalAvatar>
          <ChallengeModalName>{duel?.['creator-id'] === session.user.id ? session.user.name : duel?.opponent?.name}</ChallengeModalName>
        </ChallengeModalProfile>

        <ChallengeModalScore>
          <ChallengeModalNumber>{duel?.['creator-id'] === session.user.id ? rightAnswers : duel?.opponent?.['rounds-won']}</ChallengeModalNumber>
          <ChallengeModalVs />
          <ChallengeModalNumber>{duel?.['invited-id'] === session.user.id ? rightAnswers : duel?.opponent?.['rounds-won']}</ChallengeModalNumber>
        </ChallengeModalScore>

        <ChallengeModalProfile>
          <ChallengeModalAvatar>
            <AvatarWrapper
              size="md"
              src={duel?.['invited-id'] === session.user.id ? userAvatar : opponentAvatar}
              text={duel?.['invited-id'] === session.user.id ? session.user.name : duel?.opponent?.name}
            />
          </ChallengeModalAvatar>
          <ChallengeModalName>{duel?.['invited-id'] === session.user.id ? session.user.name : duel?.opponent?.name}</ChallengeModalName>
        </ChallengeModalProfile>
      </ChallengeModalDuel>

      {currentChallenge && <DuelsPlayerSpinWheel />}

      <ChallengeModalWarning>
        <img
          src={timeIcon}
          alt="ícone tempo"
        />
        Tente fazer no menor tempo!
      </ChallengeModalWarning>
    </ChallengeModalSection>
  );
}
